<template>
    <div class="wrapper">
        <v-layout>
            <v-main style="">
                <v-container>
                    <v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                                        <h4 class="
                                        text-h6
                                        text-md-h6
                                        text-lg-h5
                                        text-xl-h5
                                        text-truncate">
                                            Imprint
                                        </h4>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" lg="8" xl="8">
                            <b>Responsible for the website</b><br />
                            Department of Medical Bioinformatics, University Medical Center Göttingen<br />
                            Goldschmidtstraße 1<br />
                            37077 Göttingen<br />
                            Germany<br /><br />



                            Prof. Tim Beißbarth<br />
                            Goldschmidtstraße 1<br/>
                            37077 Göttingen <br />
                            Germany<br/><br />
                            Email: office@bioinf.med.uni-goettingen.de<br />
                            Website: <a href="https://bioinformatics.umg.eu">https://bioinformatics.umg.eu</a> <br /><br/>
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-layout>
    </div>
</template>
<style>
</style>